import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ac23c51"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-group-chat-create-items" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-group-add" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_group_chat_create = _resolveComponent("message-group-chat-create")!
  const _component_messages_conversation_item = _resolveComponent("messages-conversation-item")!
  const _component_app_skeleton_contact = _resolveComponent("app-skeleton-contact")!
  const _component_message_group_chat_info = _resolveComponent("message-group-chat-info")!
  const _component_app_item_wrapper = _resolveComponent("app-item-wrapper")!

  return (_openBlock(), _createBlock(_component_app_item_wrapper, null, {
    main: _withCtx(() => [
      (!_ctx.skeleton)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (!_ctx.mainStore.isMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createGroup = true)),
                    class: "group-chat-create"
                  }, [
                    _createElementVNode("div", _hoisted_2, [
                      _hoisted_3,
                      _createElementVNode("p", null, _toDisplayString(_ctx.$localize('messages.create.group')), 1)
                    ])
                  ]),
                  (_ctx.createGroup)
                    ? (_openBlock(), _createBlock(_component_message_group_chat_create, {
                        key: 0,
                        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createGroup = false))
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conversations, (conv) => {
              return (_openBlock(), _createBlock(_component_messages_conversation_item, {
                key: conv.conversationId,
                conversation: conv,
                onOpenGroupInfo: _ctx.openGroupInfo
              }, null, 8, ["conversation", "onOpenGroupInfo"]))
            }), 128))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_app_skeleton_contact),
            _createVNode(_component_app_skeleton_contact),
            _createVNode(_component_app_skeleton_contact)
          ], 64)),
      (_ctx.isGroupInfo)
        ? (_openBlock(), _createBlock(_component_message_group_chat_info, {
            key: 2,
            onClose: _ctx.closeGroupInfo
          }, null, 8, ["onClose"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}